<template>
    <a-space>
        <a-button
            type="primary"
            :loading="funnelStore.activeSave"
            :disabled="!funnelStore.allowSave"
            @click="saveFunnel"
        >
            <template v-if="!funnelStore.activeSave" #icon>
                <SaveOutlined />
            </template>
            {{ funnelStore.activeSave ? 'Saving…' : 'Save' }}
        </a-button>
        <a-button v-if="route.path.includes('funnel-view-edit')" type="primary" @click="publishFunnel" :disabled="!funnelStore.allowPublish">Publish</a-button>
    </a-space>
</template>

<script setup lang="ts">
import { useFunnelStore } from '@/store/modules/funnel'
import { useRoute } from 'vue-router'
import { SaveOutlined } from '@ant-design/icons-vue'

const funnelStore = useFunnelStore()
const route = useRoute()

const saveFunnel = async () => {
    if (funnelStore.activeSave) return
    await funnelStore.updateSaveState(true)
}

const publishFunnel = async () => {
    funnelStore.updatePublishState(true)
}
</script>